import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query AvgVoteByOperatorForChannel($channelIdentifier: String!) {
  avgVoteByOperatorForChannel(channelIdentifier: $channelIdentifier) {
    id,
    fullName,
    avgVote
  }
}`;

function getAvgVoteByOperatorForChannel(channelIdentifier) {
  return apollo.client.query({
    query,
    variables: {
      channelIdentifier,
    },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.avgVoteByOperatorForChannel);
}

export default getAvgVoteByOperatorForChannel;
